var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListItem", {
    attrs: { "is-recipient": "" },
    scopedSlots: _vm._u([
      {
        key: "text",
        fn: function() {
          return [
            _vm.hasCompleteVita
              ? _c("div", [
                  _c("b", [_vm._v("Möchtest du deinen Lebenslauf senden?")])
                ])
              : _c(
                  "div",
                  [
                    _vm.vitaFile
                      ? _c("div", [
                          _c("b", [
                            _vm._v(
                              "Dein Lebenslauf wurde erfolgreich hochgeladen."
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "message-list--item-vita-upload mt-3"
                            },
                            [
                              _c(
                                "div",
                                [_c("Icon", { attrs: { icon: "vita" } })],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.vitaFile.name))]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.removeVitaFile.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_c("Icon", { attrs: { icon: "close" } })],
                                  1
                                )
                              ])
                            ]
                          )
                        ])
                      : !_vm.hasCompleteVita && _vm.hasUploadedVita
                      ? _c("div", [
                          _c("div", [
                            _c("b", [
                              _vm._v(
                                "Dein skilldoo-Lebenslauf ist noch nicht vollständig."
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2" }, [
                            _vm._v(
                              "Benutze deinen bereits hochgeladenen Lebenslauf:"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "message-list--item-vita-upload mt-3"
                            },
                            [
                              _c(
                                "div",
                                [_c("Icon", { attrs: { icon: "vita" } })],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.vitaUrl,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.vitaInfo.documentName))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.openUploadPrompt.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_c("Icon", { attrs: { icon: "edit" } })],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.$emit("deleteDocument")
                                      }
                                    }
                                  },
                                  [_c("Icon", { attrs: { icon: "close" } })],
                                  1
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2" }, [
                            _vm._v(
                              "...oder noch besser - Vervollständige deinen skilldoo-Lebenslauf:"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c("Button", {
                                attrs: {
                                  text: "Lebenslauf vervollständigen",
                                  icon: "caret-right",
                                  href: _vm.profileVitaUrl,
                                  smaller: ""
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : [
                          _c("b", [
                            _vm._v(
                              "Dein skilldoo-Lebenslauf ist noch nicht vollständig."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Steigere deine Chancen und verwende den skilldoo-Lebenslauf, der von Personalexperten entwickelt wurde. 1x schnell ausfüllen, immer verwenden."
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center flex-column flex-md-row mt-3"
                            },
                            [
                              _c("Button", {
                                attrs: {
                                  text: "Lebenslauf vervollständigen",
                                  icon: "caret-right",
                                  href: _vm.profileVitaUrl,
                                  smaller: ""
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "ml-0 ml-md-2 mt-2 mt-md-0" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "color-turquoise",
                                      attrs: { href: "#" },
                                      on: { click: _vm.openUploadPrompt }
                                    },
                                    [_vm._v("Lebenslauf hochladen")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                    _vm._v(" "),
                    _c("input", {
                      ref: "vitaUpload",
                      staticClass: "d-none",
                      attrs: { type: "file", accept: _vm.acceptedMimeTypes },
                      on: { change: _vm.vitaFileChanged }
                    })
                  ],
                  2
                )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }